module.exports = __webpack_public_path__ + "img/logo-iris-bw.81276a07.png";